export default __webpack_public_path__ + "static/gettingDark-4d691cd1c3b94eecef5406902a5189e5.svg";